import { translate } from '../../../../utils';
import { HeadCell } from '../../../../ui-kit';
import { PendingDeliveryListsItem } from './types';

export const pendingDeliveryListsHeadCells: HeadCell<PendingDeliveryListsItem & { actions: unknown }>[] = [
    { id: 'createdAtUtc', label: translate('Date') },
    { id: 'filename', label: translate('File') },
    { id: 'status', label: translate('Status') },
    { id: 'actions', label: translate('Actions') },
];
